import { createApi } from "@reduxjs/toolkit/query/react";
import { dynamicBaseQuery } from "../constants/services";
import { toUTC } from "../utils/date";

export const activeAlertsApi = createApi({
	reducerPath: "activeAlertsApi",
	baseQuery: dynamicBaseQuery,
	endpoints: (builder) => ({
		getActiveFaultCodes: builder.query<any, { assetId: string; page?: number; pageSize?: number; startAt: string; endAt: string }>({
			query: ({ assetId, page = 0, pageSize = 10, startAt, endAt }) => ({
				url: `/faultCodes/active?assetId=${assetId}&page=${page}&pageSize=${pageSize}&startAt=${encodeURIComponent(toUTC(startAt))}&endAt=${encodeURIComponent(toUTC(endAt))}`,
				responseHandler: async (response: Response) => {
					const data = await response.json();
					return data;
				},
			}),
		}),
		getInactiveFaultCodes: builder.query<any, { assetId: string; page?: number; pageSize?: number; startAt: string; endAt: string }>({
			query: ({ assetId, page = 0, pageSize = 10, startAt, endAt }) => ({
				url: `/faultCodes/inactive?assetId=${assetId}&page=${page}&pageSize=${pageSize}&startAt=${encodeURIComponent(toUTC(startAt))}&endAt=${encodeURIComponent(toUTC(endAt))}`,
				responseHandler: async (response: Response) => {
					const data = await response.json();
					return data;
				},
			}),
		}),
	}),
});

export const { useGetActiveFaultCodesQuery, useGetInactiveFaultCodesQuery } = activeAlertsApi;
